import React, { Fragment } from "react";

import Hero from "../components/Hero";

const Home = () => (
  <Fragment>
    <Hero />
    <hr />
  </Fragment>
);

export default Home;
